import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import {MEASUREMENT_MAX_CM, MEASUREMENT_MIN_CM} from '../../lib/measurement-constants';
import {parseMeasurementValueCm} from '../../lib/measurement-value';

export type MeasurementValueFormValues = {
  readonly valueCm: string;
};

export const MEASUREMENT_VALUE_MESSAGE = `Enter a value between ${MEASUREMENT_MIN_CM} and ${MEASUREMENT_MAX_CM} cm.`;

/** A single typed girth, as the edit-entry dialog collects it. */
export class MeasurementValueValidator implements Validator<MeasurementValueFormValues> {
  readonly standardSchema = z.object({
    valueCm: z
      .string()
      .refine(value => parseMeasurementValueCm(value) !== null, MEASUREMENT_VALUE_MESSAGE),
  });

  validate(value: unknown): Result<MeasurementValueFormValues, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid measurement value.'),
      );
    }
    return ok(parsed.data);
  }
}
